import { useEffect, useState } from "react";
import { useVariant } from "../context/VariantContext";

export default function PcSidebar() {
  const { navItems, tagline, logoSignWhiteSvg, logoWhiteSvg, ctaHref, ctaBadge, ctaText } = useVariant();
  const [activeId, setActiveId] = useState("");

  useEffect(() => {
    const ids = navItems.map((item) => item.href.slice(1));
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        }
      },
      { rootMargin: "-30% 0px -60% 0px" }
    );

    for (const id of ids) {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    }

    return () => observer.disconnect();
  }, [navItems]);

  return (
    <>
      {/* 左: ブランド */}
      <div className="lp__pc-left">
        <div className="lp__pc-left__inner">
          <p className="lp__pc-left__tagline">
            {tagline.map((line, i) => (
              <span key={i}>{i > 0 && <br />}{line}</span>
            ))}
          </p>
          <img
            className="lp__pc-left__sign"
            src={logoSignWhiteSvg}
            alt=""
          />
          <img
            className="lp__pc-left__logo"
            src={logoWhiteSvg}
            alt="たっぷ"
          />
        </div>
      </div>

      {/* 右: ナビ + CTA */}
      <div className="lp__pc-right">
        <div className="lp__pc-right__inner">
          <nav className="lp__pc-right__nav">
            <ul className="lp__pc-right__nav-list">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className={`lp__pc-right__nav-link${
                      activeId === item.href.slice(1) ? " is-active" : ""
                    }`}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <a className="lp__pc-right__cta" href={ctaHref}>
            <span className="lp__pc-right__cta-badge">{ctaBadge}</span>
            <span className="lp__pc-right__cta-text">{ctaText}</span>
          </a>
        </div>
      </div>
    </>
  );
}
